// extracted by mini-css-extract-plugin
export default {"device-authorize":"pxCVdU","deviceAuthorize":"pxCVdU","cardContentPadding":"_sz9h3","qrSlot":"cimRYa","qrWrapper":"yraqIX","symphonySubtitle":"gD0Ofl","symphonySteps":"zdmlEY"};